<div class="flex flex-row justify-between items-baseline content-baseline">
  <div class="validation-errors-list">
    <span>{{data.detail}}</span>
    @if (validationErrorsList.length) {
      <div class="flex flex-col error-messages-list">
        <ul>
          @for (validationError of validationErrorsList; track validationError) {
            <li>
              @for (errorMessage of validationError.errorMessagesList; track errorMessage) {
                <div>
                  <span>{{validationError.fieldName.replaceAll('_', ' ') | titlecase}}: </span>
                  <span class="error-message">{{errorMessage}}</span>
                </div>
              }
            </li>
          }
        </ul>
      </div>
    }
  </div>

  @if (validationErrorsList.length) {
    <div class="dismiss">
      <button mat-icon-button (click)="snackBarRef.dismiss()">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  }
</div>
